var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row setting" }, [
      _c("div", { staticClass: "col col-50" }, [
        _c("span", { staticClass: "subtitle" }, [
          _vm._v("Factuur " + _vm._s(_vm.invoice.id))
        ]),
        _c("br"),
        _vm._v("\n            € " + _vm._s(_vm.invoice.price) + "\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-50" }, [
        _vm._v("\n            fsdff\n        ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27c69218", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c69218","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/Invoice.vue
// module id = null
// module chunks = 